// @flow

import { type Receipt } from '@tectonics/prs/receipts';
import { type LocalTaxCode, type LocalTax } from '@tectonics/prs/money';

export function getLocalTax(receipt: Receipt, localTaxCode: LocalTaxCode): ?LocalTax {
  return receipt.local_taxes.find(tax => tax.code === localTaxCode);
}
